// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller.js"
application.register("application", ApplicationController)

import ComboboxController from "./combobox_controller.js"
application.register("combobox", ComboboxController)

import ArticleEditorController from "./article_editor_controller.js"
application.register("article-editor", ArticleEditorController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import EditorController from "./editor_controller.js"
application.register("editor", EditorController)

import FlashController from "./flash_controller.js"
application.register("flash", FlashController)

import HeaderController from "./header_controller.js"
application.register("header", HeaderController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import LogoController from "./logo_controller.js"
application.register("logo", LogoController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import ProductController from "./product_controller.js"
application.register("product", ProductController)

import AdminCategoriesController from "./admin_categories_controller.js"
application.register("admin-categories", AdminCategoriesController)

import AdminUsersController from "./admin_users_controller.js"
application.register("admin-users", AdminUsersController)

import AdminTagsController from "./admin/tags_controller.js"
application.register("admin--tags", AdminTagsController)

import ConfirmationController from "./confirmation_controller.js"
application.register("confirmation", ConfirmationController)

import CartController from "./cart_controller.js"
application.register("cart", CartController)

import ImportController from "./import_controller.js"
application.register("import", ImportController)

import InvoiceRefreshController from "./invoice_refresh_controller.js"
application.register("invoice-refresh", InvoiceRefreshController)

import CouponController from "./coupon_controller.js"
application.register("coupon", CouponController)

import PointsRedeemController from "./points_redeem_controller.js"
application.register("points-redeem", PointsRedeemController)

import CategoriesCarouselController from "./categories_carousel_controller.js"
application.register("categories-carousel", CategoriesCarouselController)

import HomeController from "./home_controller.js"
application.register("home", HomeController)

import HomeEditorController from "./home_editor_controller.js"
application.register("home-editor", HomeEditorController)

import FooterEditorController from "./footer_editor_controller.js"
application.register("footer-editor", FooterEditorController)

import ProductSortController from "./product_sort_controller.js"
application.register("product-sort", ProductSortController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import SearchFiltersController from "./search_filters_controller.js"
application.register("search-filters", SearchFiltersController)


import ChatWidgetController from "./chat_widget_controller.js"
application.register("chat-widget", ChatWidgetController)

import PushNotificationsController from "./push_notifications_controller.js"
application.register("push-notifications", PushNotificationsController)
